import { z } from 'zod'

import { useTranslation } from '@flecto/translations'
import { type CoreInsurancePayload } from '@flecto/types'

export function useFormCreateInsurancePolicySchema() {
  const { t } = useTranslation('shared', { keyPrefix: 'validation' })

  const schema = z.object({
    customer_id: z.union([
      z.string().min(1, { message: t('required') }),
      z.number(),
    ]),
    item_id: z.union([
      z.string().min(1, { message: t('required') }),
      z.number(),
    ]),
    start_at: z.string().min(1, { message: t('required') }),
    end_at: z.string().min(1, { message: t('required') }),
    quantity: z.number().min(1, {
      message: t('minimun', {
        quantity: 1,
      }),
    }),
  })

  const initialValues: Partial<
    CoreInsurancePayload & { start_at_now?: boolean }
  > = {
    start_at_now: true,
    customer_id: undefined,
    end_at: undefined,
    item_id: undefined,
    notes: undefined,
    quantity: undefined,
    incidence_value_cents: undefined,
  }

  return { schema, initialValues }
}
